import { CompanySelectionDescriptionDTO } from '@iota/iota-management-portal-v4-client';
import { createAction, props } from '@ngrx/store';

export interface CompanySelectionDescriptionResult {
    updatedCompanySelectionDescriptions: CompanySelectionDescriptionDTO[];
    removedCompanySelectionDescriptionIds: string[];
}

export enum CompanySelectionDescriptionActionTypes {
    LoadCompanySelectionDescriptionByCompanyId = '[CompanySelectionDescription] LoadCompanySelectionDescriptionByompanyId',
    LoadCompanySelectionDescriptionSuccess = '[CompanySelectionDescription] LoadCompanySelectionDescriptionSuccess',
    LoadCompanySelectionDescriptionFailure = '[CompanySelectionDescription] LoadCompanySelectionDescriptionFailure',

    ReloadCompanySelectionDescriptionByIds = '[CompanySelectionDescription] ReloadCompanySelectionDescriptionByIds',
    ReloadCompanySelectionDescriptionByIdsSuccess = '[CompanyProductSelection] ReloadCompanySelectionDescriptionByIdsSuccess',
    ReloadCompanySelectionDescriptionByIdsFailure = '[CompanyProductSelection] ReloadCompanySelectionDescriptionByIdsFailure',

    AddUpdateRemoveCompanySelectionDescriptions = '[CompanySelectionDescriptioin] AddUpdateRemoveCompanySelectionDescription',
    AddUpdateRemoveCompanySelectionDescriptionsSuccess = '[CompanySelectionDescriptioin] AddUpdateRemoveCompanySelectionDescriptionSuccess',
    AddUpdateRemoveCompanySelectionDescriptionsFailure = '[CompanySelectionDescriptioin] AddUpdateRemoveCompanySelectionDescriptionFailure'
}

export const ReloadCompanySelectionDescriptionByIds = createAction(
    CompanySelectionDescriptionActionTypes.ReloadCompanySelectionDescriptionByIds,
    props<{ companySelectionDescriptionIds: string[] }>()
);
export const ReloadCompanySelectionDescriptionByIdsSuccess = createAction(
    CompanySelectionDescriptionActionTypes.ReloadCompanySelectionDescriptionByIdsSuccess,
    props<{ companySelectionDescriptions: CompanySelectionDescriptionDTO[] }>()
);

export const LoadCompanySelectionDescriptionByCompanyId = createAction(
    CompanySelectionDescriptionActionTypes.LoadCompanySelectionDescriptionByCompanyId,
    props<{ companyId: string }>()
);

export const LoadCompanySelectionDescriptionSuccess = createAction(
    CompanySelectionDescriptionActionTypes.LoadCompanySelectionDescriptionSuccess,
    props<{
        companyId: string;
        companySelectionDescriptions: CompanySelectionDescriptionDTO[];
    }>()
);

export const LoadCompanySelectionDescriptionFailure = createAction(
    CompanySelectionDescriptionActionTypes.LoadCompanySelectionDescriptionFailure,
    props<{ error: any }>()
);

export const ReloadCompanySelectionDescriptionByIdsFailure = createAction(
    CompanySelectionDescriptionActionTypes.ReloadCompanySelectionDescriptionByIdsFailure,
    props<{ error: any }>()
);

export const AddUpdateRemoveCompanySelectionDescriptions = createAction(
    CompanySelectionDescriptionActionTypes.AddUpdateRemoveCompanySelectionDescriptions,
    props<{ upsertedCompanySelectionDescriptions?: CompanySelectionDescriptionResult; companyId: string }>()
);
export const AddUpdateRemoveCompanySelectionDescriptionsSuccess = createAction(
    CompanySelectionDescriptionActionTypes.AddUpdateRemoveCompanySelectionDescriptionsSuccess
);
export const AddUpdateRemoveCompanySelectionDescriptionsFailure = createAction(
    CompanySelectionDescriptionActionTypes.AddUpdateRemoveCompanySelectionDescriptionsFailure,
    props<{ error: any }>()
);
